import { TrackListSource } from '@epicuro-next/features/engagement/list-utils/models';
import { createAction, props } from '@ngrx/store';

/**
 * Can be used to set or clear
 */
export const setLookbookIdInRouter = createAction(
  '[ShopTheLook] set lookbook id in router',
  props<{ lookbookId?: string }>(),
);

/**
 * Can be used to set or clear
 */
export const setLookbookListIdInRouter = createAction(
  '[ShopTheLook] set lookbook list id in router',
  props<{ lookbookListId?: string }>(),
);

export const lookClosed = createAction(
  '[ShopTheLook] LookBook list closed',
  props<{ lookBookId: string; listId: string }>(),
);

export const trackLookBook = createAction(
  '[ShopTheLook] Track lookbook list analytics',
  props<{
    lookbookId: string;
    productListId: string;
    source: TrackListSource;
  }>(),
);

export const setListEditClickedFromLookbook = createAction(
  '[ShopThelook] list edit clicked from lookbook state',
  props<{ listEditClickedFrom?: { lookbookId: string; listId: string } }>(),
);
